import { useTranslation } from "react-i18next";
import { CategoryInfoListType } from "../types/category_info_type";
import Gauge from "../../../../icons/Gauge_L.svg";

interface InferenceFactorLengendProps {
  categoryInfoList: CategoryInfoListType;
  setIsShowLegend: React.Dispatch<React.SetStateAction<boolean>>;
}

export const InferenceFactorLengend: React.FC<InferenceFactorLengendProps> = ({
  categoryInfoList,
  setIsShowLegend,
}) => {
  //OKボタン押下時
  const handleOnOK = () => {
    setIsShowLegend(false);
  };

  // 言語切り替え用
  const { t } = useTranslation();

  //#の有無を判定して#が無いものには#を付与する関数
  const ensureHash = (colorCode: string): string => {
    return colorCode[0] === "#" ? colorCode : `#${colorCode}`;
  };

  return (
    <>
      <div
        className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75"
        onClick={handleOnOK}
      >
        <div
          className="flex flex-col bg-white w-3/4 max-h-[80vh]"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-center font-bold mt-4">
            {t("推定要因項目画面.カテゴリ")}
          </h2>
          <div className="flex-1 overflow-y-scroll">
            {/* 現在のカテゴリ名を表示 */}
            {categoryInfoList.category.map((category) => {
              const bg = category?.backColor?.trim();
              const border = category?.fontColor?.trim();
              const bgCode = bg ? ensureHash(bg) : "#ffffff";
              const borderCode = border ? ensureHash(border) : "#000000";
              return (
                <div
                  style={{
                    ["--cat-bg" as any]: bgCode,
                    ["--cat-text" as any]: borderCode,
                  }}
                  className={`border-2 border-[var(--cat-text)] rounded mx-3 my-3 px-3 py-2 bg-[var(--cat-bg)]`}
                  key={category.label}
                >
                  {category.label}
                </div>
              );
            })}
            {/* 工数 */}
            <div className="flex justify-center items-end mb-2">
              <div className="flex flex-col items-center gap-4 w-[38.25px]">
                <p>{t("推定要因項目画面.大")}</p>
                <p>{t("推定要因項目画面.小")}</p>
              </div>
              <div className="flex flex-col justify-center items-center py-1">
                <h2 className="text-center font-bold mt-2">
                  {t("推定要因項目画面.工数")}
                </h2>
                <img
                  src={Gauge}
                  alt="工数アイコン"
                  className="w-14 h-auto px-2"
                />
              </div>
              {/* アイコン位置を中心にするための調整用 */}
              <div className="w-[38.25px]">{""}</div>
            </div>
          </div>
          <button
            className="text-sub-blue border-t border-black w-full py-2"
            onClick={handleOnOK}
          >
            OK
          </button>
        </div>
      </div>
    </>
  );
};
